import { useState, useEffect, useCallback, useMemo } from 'react';
import axiosInstance from '../api/axiosInstance';
import { getUserInfoDetails } from '../utlis';

const cache = {};

const useFetch = (url, param = {}) => {
    const { companyId, clientId } = getUserInfoDetails() || {};
    const paramsObj = useMemo(() => {
        return Object.keys(param).length ? param : { company: companyId, client: clientId };
    }, [JSON.stringify(param), companyId, clientId]);

    const cacheKey = `${url}_${JSON.stringify(paramsObj)}`;

    const [data, setData] = useState(cache[cacheKey] || null);
    const [loading, setLoading] = useState(!cache[cacheKey]);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.get(url, { params: paramsObj });
            const result = response.data;
            cache[cacheKey] = result;
            setData(result);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [url, cacheKey, paramsObj]);

    useEffect(() => {
        if (!cache[cacheKey]) {
            fetchData();
        }
    }, [cacheKey, fetchData]);

    const refetch = () => {
        delete cache[cacheKey];
        fetchData();
    };

    return { data, loading, error, refetch };
};

export default useFetch;
